const BASE_CLASSNAME = "input-text"

const TextInput = ({className, leading, trailing, header, footer, ...props}) => {
    className = className ? `${BASE_CLASSNAME} ${className}` : `input ${BASE_CLASSNAME}`
    return <div className={className}>
        <div className={`${BASE_CLASSNAME}__header`}>{header}</div>
        <div className="u-flex--row">
            <div className={`${BASE_CLASSNAME}__leading`}>{leading}</div>
            <input type="text" {...props} />
            <div className={`${BASE_CLASSNAME}__trailing`}>{trailing}</div>
        </div>
        <div className={`${BASE_CLASSNAME}__footer`}>{footer}</div>
    </div>
}

export default TextInput